import { UserModel } from '../user';
export class EmergencyContact extends UserModel {
  relationship: string;
}
